import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-50" role="contentinfo">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto py-14 md:py-20">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
            <div className="md:col-span-4">
              <Link to="/" className="inline-block cursor-pointer">
                <span className="text-3xl md:text-4xl font-heading text-primary-400">
                  虫虫漫画
                </span>
              </Link>
              <p className="mt-4 text-sm text-foreground-400 leading-relaxed max-w-xs">
                虫虫漫画作为最新最全的漫画官网，提供免费在线漫画阅读服务，资源权威且全面，更新同步，是漫画爱好者信赖的官方渠道。
              </p>
              <div className="mt-6 flex items-center gap-3">
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-600 text-foreground-400 hover:text-primary-400 hover:border-primary-400 transition-colors cursor-pointer"
                  aria-label="微博"
                  rel="nofollow"
                >
                  <i className="ri-weibo-line"></i>
                </a>
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-600 text-foreground-400 hover:text-primary-400 hover:border-primary-400 transition-colors cursor-pointer"
                  aria-label="微信"
                  rel="nofollow"
                >
                  <i className="ri-wechat-line"></i>
                </a>
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-600 text-foreground-400 hover:text-primary-400 hover:border-primary-400 transition-colors cursor-pointer"
                  aria-label="B站"
                  rel="nofollow"
                >
                  <i className="ri-bilibili-line"></i>
                </a>
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-600 text-foreground-400 hover:text-primary-400 hover:border-primary-400 transition-colors cursor-pointer"
                  aria-label="抖音"
                  rel="nofollow"
                >
                  <i className="ri-tiktok-line"></i>
                </a>
              </div>
            </div>

            <div className="md:col-span-2">
              <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-300 mb-4">
                快速导航
              </h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/category/xuanhuan" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                    漫画分类
                  </Link>
                </li>
                <li>
                  <Link to="/article/1" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                    最新资讯
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                    关于我们
                  </Link>
                </li>
              </ul>
            </div>

            <div className="md:col-span-2">
              <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-300 mb-4">
                热门分类
              </h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/category/xuanhuan" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                    玄幻漫画
                  </Link>
                </li>
                <li>
                  <Link to="/category/rexue" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                    热血漫画
                  </Link>
                </li>
                <li>
                  <Link to="/category/lianai" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                    恋爱漫画
                  </Link>
                </li>
                <li>
                  <Link to="/category/wuxia" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                    武侠漫画
                  </Link>
                </li>
              </ul>
            </div>

            <div className="md:col-span-4">
              <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-300 mb-4">
                联系我们
              </h4>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <i className="ri-map-pin-line text-foreground-400 mt-0.5"></i>
                  <span className="text-sm text-foreground-400">北京市朝阳区漫画产业园A座</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-phone-line text-foreground-400 mt-0.5"></i>
                  <span className="text-sm text-foreground-400">400-888-6666</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-mail-line text-foreground-400 mt-0.5"></i>
                  <span className="text-sm text-foreground-400">hello@x21ta.cn</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800">
          <div className="max-w-[1400px] mx-auto py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; {currentYear} 虫虫漫画 版权所有
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">
                服务条款
              </a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">
                版权声明
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Organization Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '虫虫漫画',
            url: 'http://x21ta.cn/',
            description: '虫虫漫画作为最新最全的漫画官网，提供免费在线漫画阅读服务，资源权威且全面，更新同步，是漫画爱好者信赖的官方渠道。',
            contactPoint: {
              '@type': 'ContactPoint',
              telephone: '400-888-6666',
              contactType: 'customer service',
              availableLanguage: ['Chinese'],
            },
            address: {
              '@type': 'PostalAddress',
              addressLocality: '北京',
              addressCountry: 'CN',
              streetAddress: '朝阳区漫画产业园A座',
            },
          }),
        }}
      />
    </footer>
  );
}